import React from 'react';
import { useTranslation } from '../utils/i18n';
import IkiSymbol from './IkiSymbol';

const PersonalVoiceWelcomeModal = ({ isOpen, onClose, onRecordNow }) => {
  const { t, language } = useTranslation();

  if (!isOpen) return null;

  const content = {
    title: "Welcome to Your Personal Voice",
    message: "Your voice is the most intimate frequency of your being. By recording it, you're not creating data, you're creating a sound mirror of your consciousness. HYPSEYA uses this sample only to generate meditations and affirmations in your own voice, privately and securely encrypted. We never share or use your recordings for any other purpose. When you hear yourself speaking to yourself, your body recognizes the vibration. That's how change begins, from within.",
    primaryButton: "Record now",
    secondaryButton: "Later",
    footerNote: "Private & Encrypted"
  };

  const data = content;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #F7F3EC 0%, #EFE7DD 100%)',
        borderRadius: '24px',
        maxWidth: '600px',
        width: '100%',
        padding: '48px',
        boxShadow: '0 20px 60px rgba(30, 107, 104, 0.3)',
        position: 'relative',
        animation: 'modalFadeIn 0.3s ease-out'
      }}>
        
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            color: '#999',
            cursor: 'pointer',
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          aria-label="Close"
        >
          ×
        </button>

        {/* Icon */}
        <div style={{
          textAlign: 'center',
          marginBottom: '24px'
        }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(30, 107, 104, 0.1) 0%, rgba(184, 211, 207, 0.2) 100%)',
            marginBottom: '16px'
          }}>
            <IkiSymbol name="mic" size="xl" />
          </div>
        </div>

        {/* Title */}
        <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: '2rem',
          color: '#1E6B68',
          textAlign: 'center',
          marginBottom: '24px',
          lineHeight: '1.3'
        }}>
          {data.title}
        </h2>

        {/* Message */}
        <p style={{
          fontSize: '1rem',
          lineHeight: '1.8',
          color: '#666',
          textAlign: 'center',
          marginBottom: '32px'
        }}>
          {data.message}
        </p>

        {/* Footer note with lock icon */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          padding: '12px',
          background: 'rgba(30, 107, 104, 0.08)',
          borderRadius: '12px',
          marginBottom: '32px'
        }}>
          <IkiSymbol name="lock" size="sm" />
          <span style={{
            fontSize: '0.9rem',
            color: '#1E6B68',
            fontWeight: '600'
          }}>
            {data.footerNote}
          </span>
        </div>

        {/* Buttons */}
        <div style={{
          display: 'flex',
          gap: '16px',
          flexDirection: 'column'
        }}>
          <button
            onClick={onRecordNow}
            style={{
              padding: '16px 32px',
              background: 'linear-gradient(135deg, #1E6B68 0%, #2D8B87 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '24px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 16px rgba(30, 107, 104, 0.4)',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            {data.primaryButton}
          </button>

          <button
            onClick={onClose}
            style={{
              padding: '14px 32px',
              background: 'transparent',
              color: '#1E6B68',
              border: '2px solid rgba(30, 107, 104, 0.3)',
              borderRadius: '24px',
              fontSize: '1rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.borderColor = '#1E6B68';
              e.target.style.background = 'rgba(30, 107, 104, 0.05)';
            }}
            onMouseOut={(e) => {
              e.target.style.borderColor = 'rgba(30, 107, 104, 0.3)';
              e.target.style.background = 'transparent';
            }}
          >
            {data.secondaryButton}
          </button>
        </div>
      </div>

      <style>
        {`
          @keyframes modalFadeIn {
            from {
              opacity: 0;
              transform: scale(0.95);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}
      </style>
    </div>
  );
};

export default PersonalVoiceWelcomeModal;
